import type { RouteRecordRaw } from 'vue-router'

export const scribeRoutes: RouteRecordRaw[] = [
  {
    path: '/scribe',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: {
      requiresAuth: true,
      module: 'scribe',
      moduleDisplayName: 'Scribe',
    },
    children: [
      {
        path: '',
        name: 'scribe-queue',
        component: () => import('@/modules/scribe/views/ScribeQueueView.vue'),
      },
    ],
  },
]
